export default {
  en: {
    dashboardPage: {
      country: "Cameroon", offline: "Offline", offlineMode: "Offline Mode",
      closeMenu: "Close menu", openMenu: "Open menu", switchLanguage: "Switch language",
      resultsSubmitted: "Results submitted", acrossStations: "Across all stations",
      rejected: "{{count}} rejected",
      interactiveMap: "Interactive Map", viewCouncils: "View councils",
      pollingStations: "Polling Stations", manageStations: "Manage stations",
      submitResults: "Submit Results", addData: "Add new data",
      viewResults: "View Results", browseResults: "Browse results",
      collation: "Results Collation", aggregate: "Aggregate data",
      projectedWinners: "Projected Winners", leadingParties: "Leading parties",
      electionNight: "Election Night", live: "LIVE", allTypesLive: "All election types live",
      elections: "Elections", allTypes: "All Types", electionsDesc: "Presidential, Parliamentary, more",
      partyTrends: "Party Trends", perfAnalytics: "Performance analytics",
      historical: "Historical Comparison", crossCycle: "Cross-cycle trends",
      publicResults: "Public Results Dashboard", public: "Public", publicDesc: "Live election results - all types",
      verificationPortal: "Verification Portal", verifier: "Verifier", approveResults: "Approve results",
      statistics: "Statistics", viewAnalytics: "View analytics",
      candidates: "Candidates", manageCandidates: "Manage candidates",
      liveReporting: "Live Reporting", pro: "Pro", realtime: "Real-time updates",
      analytics: "Analytics", new: "New", allDashboards: "All dashboards & insights",
      notifications: "Notifications", alertsInbox: "Alerts & inbox",
      settings: "Settings", preferences: "Preferences",
      subscription: "Subscription", managePlan: "Manage plan",
      adminPanel: "Admin Panel", admin: "Admin", userManagement: "User management",
      typeMgmt: "Election Type Management",
      typeMgmtDesc: "Manage results, candidates, and analytics for each election type",
      presidential: "Presidential", parliamentary: "Parliamentary", senatorial: "Senatorial",
      regional: "Regional", council: "Council",
      presScope: "National scope • All 10 regions", parlScope: "180 Constituencies • Proportional",
      senScope: "10 Regions • 70 seats", regScope: "NW & SW only • Special status",
      councilScope: "357 Councils • Local level", viewManage: "View & Manage"
    }
  },
  fr: {
    dashboardPage: {
      country: "Cameroun", offline: "Hors ligne", offlineMode: "Mode hors ligne",
      closeMenu: "Fermer le menu", openMenu: "Ouvrir le menu", switchLanguage: "Changer de langue",
      resultsSubmitted: "Résultats soumis", acrossStations: "Tous bureaux confondus",
      rejected: "{{count}} rejeté(s)",
      interactiveMap: "Carte interactive", viewCouncils: "Voir les communes",
      pollingStations: "Bureaux de vote", manageStations: "Gérer les bureaux",
      submitResults: "Soumettre les résultats", addData: "Ajouter de nouvelles données",
      viewResults: "Voir les résultats", browseResults: "Parcourir les résultats",
      collation: "Compilation des résultats", aggregate: "Agréger les données",
      projectedWinners: "Vainqueurs projetés", leadingParties: "Partis en tête",
      electionNight: "Soirée électorale", live: "EN DIRECT", allTypesLive: "Tous types d'élections en direct",
      elections: "Élections", allTypes: "Tous types", electionsDesc: "Présidentielle, législatives, et plus",
      partyTrends: "Tendances des partis", perfAnalytics: "Analyse des performances",
      historical: "Comparaison historique", crossCycle: "Tendances entre les cycles",
      publicResults: "Tableau de bord public des résultats", public: "Public", publicDesc: "Résultats électoraux en direct - tous types",
      verificationPortal: "Portail de vérification", verifier: "Vérificateur", approveResults: "Approuver les résultats",
      statistics: "Statistiques", viewAnalytics: "Voir les analyses",
      candidates: "Candidats", manageCandidates: "Gérer les candidats",
      liveReporting: "Reportage en direct", pro: "Pro", realtime: "Mises à jour en temps réel",
      analytics: "Analyses", new: "Nouveau", allDashboards: "Tous les tableaux de bord et analyses",
      notifications: "Notifications", alertsInbox: "Alertes et boîte de réception",
      settings: "Paramètres", preferences: "Préférences",
      subscription: "Abonnement", managePlan: "Gérer le forfait",
      adminPanel: "Panneau d'administration", admin: "Admin", userManagement: "Gestion des utilisateurs",
      typeMgmt: "Gestion par type d'élection",
      typeMgmtDesc: "Gérez les résultats, les candidats et les analyses pour chaque type d'élection",
      presidential: "Présidentielle", parliamentary: "Législatives", senatorial: "Sénatoriales",
      regional: "Régionales", council: "Municipales",
      presScope: "Portée nationale • Les 10 régions", parlScope: "180 circonscriptions • Proportionnelle",
      senScope: "10 régions • 70 sièges", regScope: "Nord-Ouest et Sud-Ouest uniquement • Statut spécial",
      councilScope: "357 communes • Niveau local", viewManage: "Consulter et gérer"
    }
  }
};
